<template>

  <div class="container activation-options welcome-back">
    <h1 class="section-title">Account complete</h1>
    <p class="text-normal">
      Congratulations your account has been created. Please enter a valid email address and password to complete your account.
    </p>
    <p class="sub-text">These details will be used for you to login to your account</p>
    <div>
      <div class="subscriber-details">
        <div style="position:relative">
          <span class="details">Login Credentials</span>
          <a class="clear-input" @click="clearForm">
            Clear
            <i class="fa fa-times"></i>
          </a>
        </div>

        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Enter email"
            autocomplete="username"
            v-model="user_name"
            v-validate="'required|email'"
            name="email"
          />
          <transition name="slide">
            <span
              class="error-message"
              v-if="errors.has('email')"
            >A valid email address is required.</span>
          </transition>
        </div>

        <div class="form-group">
          <input
            type="password"
            class="form-control"
            name="password"
            placeholder="Password"
            v-validate="'required|min:6'"
            autocomplete="current-password"
            v-model="password"
          />
          <transition name="slide">
            <span
              class="error-message"
              v-if="errors.has('password')"
            >Password must be have atleast 6 characters.</span>
          </transition>
        </div>


        <div class="error-message" v-if="error_message != ''">{{ error_message }}</div>
        <div class="page-controls mt-3">
          <div class="row no-gutters">            
            <button
              type="button"
              class="btn btn-outline-primary btn-block btn-sm"
              @click="completeAccount"
            >
              Complete Account
              <i aria-hidden="true" class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/components/shared/event-bus';
import CustomerService from "@/services/customer.service.js";

export default {
  name: "complete",
  props: ['mobile', 'order_id'],
    data: function() {
    return {
      is_loading: false,
      display_message: false,
      error_message: "",
      has_error: false,
      user_name: "",
      password: ""
    };
  },
  mounted() {
    const self = this;
    self.$scrollTo("body");
  },
  methods: {
    completeAccount() {
      const self = this;
      self.$validator.validateAll().then(success => {
        if (success) {
          EventBus.$emit("global_loading", { is_loading: true });
          CustomerService.completeAccount(
            self.mobile,
            '123-123',
            self.order_id,
            self.user_name,
            self.password
          )
          .then(function({ data }) {
            var response = data;
            EventBus.$emit("global_loading", { is_loading: false });
            self.$log.debug("Confirm OTP response", response);
            if (response.success) {
              self.$log.debug("OTP Confirmed");
              self.account_complete = true;
              self.$emit("completed", { user_name: self.user_name, password: self.password, redirect: "/backend.html"});
            } else {
              self.display_message = true;
              self.message = response.message;
              self.has_error = true;
            }
            self.is_loading = false;
          })
          .catch(function({ response }) {
            self.$log.error("Error completing account", response);
            self.has_error = true;
            self.display_message = true;
            self.message = response.data.message;
            self.is_loading = false;
          });          
        }        
        else self.error_message = "Invalid inputs.";        
      });
    },
    clearForm() {
      const self = this;
      self.user_name = "";
      self.password = "";
    }
  }
};
</script>